import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgCa = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#D80027",
      d: "M8.276 23.411C3.472 21.844 0 17.327 0 12 0 6.638 3.517 2.098 8.37.56l3.72 1.31L15.66.568C20.496 2.115 24 6.648 24 12c0 5.309-3.448 9.813-8.226 11.395l-3.62-1.518z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#EEE",
      d: "M17.217 22.81A11.95 11.95 0 0 1 12 24c-1.87 0-3.64-.428-5.217-1.19V1.19A11.95 11.95 0 0 1 12 0c1.87 0 3.64.428 5.217 1.19z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#D80027",
      d: "m14.086 13.566 2.086-1.05-1.04-.516v-1.045L13.044 12l1.04-2.086h-1.04L12 8.344l-1.045 1.565h-1.04l1.04 2.086-2.086-1.045V12l-1.04.52 2.085 1.046-.525 1.045h2.095v1.56h1.032v-1.56h2.09z"
    })]
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "a",
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
      })
    })
  })]
});
export default SvgCa;